type TNotificationOption = 'Enabled' | 'Disabled'

export const notificationOptions: TNotificationOption[] = ['Enabled', 'Disabled']

export const AVATAR_FILE_TYPES = ['image/jpeg', 'image/png']
